import { useState } from 'react';
import {
  Button,
  Card,
  Error,
  LoadingStatus,
  Modal,
  WarningStatus,
} from '@/components/generic';
import { cn } from '@/lib/utils';
import { useHandleMFA } from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

const Security = () => {
  const { t } = useTranslation();
  const [isWarningVisible, setIsWarningVisible] = useState(false);
  const {
    isGettingMFAStatus,
    isLoading,
    isMFAEnabled,
    handleEnableMFA,
    handleDisableMFA,
    error,
  } = useHandleMFA();
  const handleToggleMFA = () => {
    setIsWarningVisible(false);
    if (isMFAEnabled) {
      handleDisableMFA();
    } else {
      handleEnableMFA();
    }
  };
  return (
    <>
      <Modal open={isWarningVisible} onClose={() => setIsWarningVisible(false)}>
        <WarningStatus
          content={
            isMFAEnabled
              ? `disable ${t('profile.mfa.title')}?`
              : `enable ${t('profile.mfa.title')}?`
          }
          onClose={() => setIsWarningVisible(false)}
          confirm={() => handleToggleMFA()}
        />
      </Modal>
      <Card title={t('profile.mfa.title')} className='m-0'>
        {isLoading || isGettingMFAStatus ? (
          <LoadingStatus />
        ) : (
          <form className='flex flex-col gap-8 p-5 pt-0 max-lg:px-3 max-md:gap-4'>
            <Button
              className={cn(
                'self-start  w-full',
                isMFAEnabled ? 'label-red' : 'label-blue',
              )}
              type='button'
              onClick={() => setIsWarningVisible(true)}
            >
              {isMFAEnabled ? `Disable MFA` : t('profile.mfa.enable')}
            </Button>
          </form>
        )}
        <Error
          error={error}
          message={
            error ||
            'An error occurred while toggling MFA. Please try again later.'
          }
        />
      </Card>
    </>
  );
};

export default Security;
